import { useQuery } from "@tanstack/react-query";
import useRevenue from "../utils/useRevenue";

const formatDate = (date) => {
  if (!date) return null;
  const [year, month] = date.split("-");
  return `${year}-${month}`;
};

export default function useCollectionsZonesRevenue({ date = null, enabled }) {
  const formattedDate = formatDate(date);
  const { getCollectionsZonesRevenue } = useRevenue();

  const { data, isLoading, error } = useQuery({
    queryKey: ["collectionsZonesRevenue", formattedDate],
    queryFn: () => getCollectionsZonesRevenue({ date: formattedDate }),
    enabled,
  });

  return { data: data?.data, isLoading, error };
}
